import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-13',
  templateUrl: './13.component.html',
  styleUrls: ['./13.component.scss'],
})
export class VbGeneral13Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
